module.exports = __webpack_public_path__ + "footer-2.jpg?05513f53fd1594ebce0f12b3c4bcf8b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-2.jpg
// module id = 284
// module chunks = 0